// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

const AccountMetrics = dynamic(() => import('./AccountMetrics').then(mod => mod.AccountMetrics));

export const AccountMetricsConfig = {
  emptyLabel: 'AccountMetrics',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/accountmetrics`,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AccountMetricsEditable = (props: any) => {
  return (
    <EditableComponent config={AccountMetricsConfig} {...props}>
      <AccountMetrics {...props} />
    </EditableComponent>
  );
};
